import LeaseExpirationCard from './LeaseExpirationCard';

export default LeaseExpirationCard;